/**
 * ConfirmDialog — Design-system primitive (re-homed from `components/v2/`).
 *
 * WAVE 6 BATCH 3: Canonical home is now `design-system/components/`. Thin
 * prop-adapter over the DS `ConfirmModal` primitive so the 9 legacy admin
 * destructive-action call sites keep their existing call surface while
 * benefiting from Phase 6.2 focus-trap + return-focus.
 *
 * Legacy prop → new prop mapping:
 *   open        → open
 *   onCancel    → onOpenChange (called with false)
 *   onConfirm   → onConfirm
 *   title       → title
 *   description → description
 *   confirmLabel/cancelLabel → same names
 *   variant     → confirmVariant  ("destructive" → "danger", else "primary")
 *   busy        → loading
 *   testId      → data-testid   (default "confirm-dialog")
 *
 * All existing testids (`{testId}-cancel`, `{testId}-confirm`) are
 * preserved by the underlying ConfirmModal primitive.
 */
import { ConfirmModal } from "@/design-system/components/ConfirmModal";

export default function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default",
  busy = false,
  testId = "confirm-dialog",
}) {
  const handleOpenChange = (next) => {
    if (busy) return;
    if (!next && typeof onCancel === "function") onCancel();
  };
  return (
    <ConfirmModal
      open={open}
      onOpenChange={handleOpenChange}
      onConfirm={onConfirm}
      title={title}
      description={typeof description === "string" ? description : undefined}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      confirmVariant={variant === "destructive" ? "danger" : "primary"}
      loading={Boolean(busy)}
      data-testid={testId}
    >
      {typeof description !== "string" ? (
        <div className="text-[13px] leading-relaxed" data-testid={`${testId}-description`}>
          {description}
        </div>
      ) : null}
    </ConfirmModal>
  );
}
